/** Inline style object for a task list item row. */
import { CSS } from '@dnd-kit/utilities';
import { getContextColor } from '@/features/tasks/utils/ui/colorUtils';
import {
  getBorderColor,
  getDisplayLevel,
  getCursor,
  buildClassNameList,
  getBaseLevel,
} from '@/features/tasks/utils/ui/taskItemStyleUtils';

export function buildTaskItemPresentation({
  task,
  allContexts,
  flags,
  isOverlay,
  isSmallScreen,
  isDragDisabled,
  transform,
  transition,
  isDragging,
  variant,
  ui,
}) {
  const accentBorderColor = getBorderColor(
    flags.isWaitingFor,
    allContexts,
    flags.isOverdue,
  );
  const displayLevel = getDisplayLevel(ui.indentationType, getBaseLevel(task));
  const style = {
    '--level': displayLevel,
    ...(accentBorderColor
      ? { '--default-border-color': accentBorderColor }
      : {}),
    '--context-color':
      allContexts.length > 0 ? getContextColor(allContexts[0]) : 'transparent',
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: getCursor(isOverlay, isSmallScreen, isDragDisabled),
    touchAction: 'none',
    ...(isDragging && !isOverlay ? { opacity: 0 } : {}),
  };

  return {
    style,
    classNames: buildClassNameList(ui.view, variant, flags),
    displayLevel,
  };
}
